import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { WorkSessionDTO } from './dtos/work-session.dto';

@Injectable({
    providedIn: 'root',
})
export class WorkSessionsApiService {
    constructor(
        private http: HttpClient
    ) {
    }

    public getActiveWorkSession(): Observable<WorkSessionDTO> {
        const url = `${BASE_PATH_API}/worksessions/self`;
        return this.http.get<any>(url);
    }
}
